import { getExternalAuthenticationSchemes } from 'api/membership';
import { useQuery } from 'react-query';
import QueryKeys from '../queryKeys';
import { IQueryOptions } from 'interfaces/ui';

function useExternalAuthentication(options?: IQueryOptions) {
  return useQuery({
    ...options,
    queryFn: async () => {
      const data = await getExternalAuthenticationSchemes();

      return data.data;
    },
    queryKey: [QueryKeys.getExternalAuthenticationSchemes],
  });
}

export default useExternalAuthentication;
